//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/activities/views/main/lan/es';
import tab from 'Modules/activities/.components/tab/lan/es';
import changeDetails from 'Modules/activities/.components/changeDetails/lan/es';

locales = { ...locales, ...main, ...tab, ...changeDetails };


export default locales;